import { HttpLink } from 'apollo-link-http';
import ApolloClient from 'apollo-client';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import gql from 'graphql-tag';
import React from 'react';
import jwt_decode from 'jwt-decode';
import { get, remove, set } from 'local-storage';
import { useMutation } from '@apollo/react-hooks';

var RefreshToken = 'RefreshToken';
var AccessToken = 'ConnectedUser';
var TemporaryToken = 'TemporarySession';
var UserData = 'UserData';

var eStorageKey = {
  userData: UserData,
  accessToken: AccessToken,
  refreshToken: RefreshToken,
  temporaryToken: TemporaryToken
};

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function useOnPremQuery(query, client) {
  return React.useCallback(function (variables) {
    return client.query({
      query: query,
      variables: variables
    });
  }, [client]);
}

function decode(token) {
  return jwt_decode(token);
}

function verify(token) {
  if (Date.now() >= token.exp * 1000) {
    return false;
  }

  return true;
}
function decodeAndVerify(token) {
  return verify(decode(token));
}

function getDate(token, key) {
  return new Date(token[key] * 1000);
}

function getCookie(key) {
  var token = getWithExpiry(key);
  if (key === UserData) return token;
  if (token && decodeAndVerify(token)) return token;
}

function getWithExpiry(key) {
  var itemStr = get(key);

  if (!itemStr) {
    return null;
  }

  var _JSON$parse = JSON.parse(itemStr),
      value = _JSON$parse.value,
      expiry = _JSON$parse.expiry;

  var now = new Date();
  if (!expiry) return value;

  if (now.getTime() > expiry) {
    remove(key);
    return null;
  }

  return value;
}

function setWithExpiry(key, value, expiry) {
  set(key, JSON.stringify({
    value: value,
    expiry: expiry && expiry.getTime()
  }));
}

function store(value, key, opt) {
  if (opt === void 0) {
    opt = {};
  }

  setWithExpiry(key.toString(), value, opt.expires);
}

var ClearStorage = function ClearStorage() {
  [RefreshToken, AccessToken, TemporaryToken, UserData].forEach(function (key) {
    return remove(key);
  });
};
var ClearTemporary = function ClearTemporary() {
  remove(TemporaryToken);
};
var ClearTokens = function ClearTokens() {
  remove(AccessToken);
  remove(RefreshToken);
};
var ClearUserData = function ClearUserData() {
  remove(UserData);
};
var GetAccessToken = function GetAccessToken() {
  return getCookie(AccessToken);
};
var GetRefreshToken = function GetRefreshToken() {
  return getCookie(RefreshToken);
};
var GetStored = function GetStored(key) {
  console.warn('Method GetStored is deprecated. Use GetTemporaryToken, GetAccessToken, GetRefreshToken, or GetUserData');
  return getCookie(eStorageKey[key] || key);
};
var GetTemporaryToken = function GetTemporaryToken() {
  return getCookie(TemporaryToken);
};
var GetUserData = function GetUserData() {
  return getCookie(UserData);
};
var Store = function Store() {
  console.warn('Method Store is deprecated. Use StoreTokens, StoreUserData, or StoreTemporaryToken');
  store.apply(void 0, arguments);
};
var StoreTemporaryToken = function StoreTemporaryToken(token) {
  store(token, TemporaryToken);
};
var StoreTokens = function StoreTokens(token, refreshToken) {
  store(token, AccessToken, {
    expires: getDate(decode(token), 'exp')
  });
  store(refreshToken, RefreshToken, {
    expires: getDate(decode(refreshToken), 'exp')
  });
};
var StoreUserData = function StoreUserData(data) {
  store(data, UserData);
};

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  query($refreshToken:String!){\n  user{\n    refreshToken(refreshToken:$refreshToken){\n      refreshToken\n      token\n    }\n  }\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var REFRESH_TOKEN = gql(_templateObject());

var RefreshTokenQuery = function RefreshTokenQuery(props) {
  var onComplete = props.onComplete,
      refreshToken = props.refreshToken;
  var client = useOnPremQuery(REFRESH_TOKEN, GeladaClient(false));
  client({
    refreshToken: refreshToken
  }).then(function (c) {
    StoreTokens(c.data.user.refreshToken.token, c.data.user.refreshToken.refreshToken);
    onComplete(c, "data");
  })["catch"](function (c) {
    return onComplete(c, "error");
  });
  return null;
};

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\nmutation($token:String!,$communityName:String,$firstname:String,$lastname:String,$password:String){\n    acceptInvitation(acceptInvitation:{tokenId:$token,communityName:$communityName ,firstName:$firstname,lastName:$lastname,password:$password}) {\n      refreshToken\n      token\n      user{\n        id\n        firstname\n        created\n        lastname\n        communityName\n        credential {\n          email\n        }\n      }\n    }\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var ACCEPT_INVITATION = gql(_templateObject$1());

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation($activationCode:String!){\n  activateAccount(activationCode:$activationCode){\n    token\n    refreshToken\n    user{\n      id\n      firstname\n      lastname\n      communityName\n      credential {\n        email\n      }\n    }\n  }\n}\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var ACTIVATE_ACCOUNT = gql(_templateObject$2());

var ActiveAccountMutation = function ActiveAccountMutation(props) {
  var onComplete = props.onComplete,
      activationCode = props.activationCode;

  var _useMutation = useMutation(ACTIVATE_ACCOUNT, {
    client: GeladaClient(false)
  }),
      client = _useMutation[0];

  client({
    variables: {
      activationCode: activationCode
    }
  }).then(function (c) {
    StoreTokens(c.data.activateAccount.token, c.data.activateAccount.refreshToken);
    onComplete(c, "data");
  })["catch"](function (c) {
    return onComplete(c, "error");
  });
  return null;
};

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation($email:String!){\n  forgotPassword(email:$email)\n}\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var FORGOT_PASSWORD = gql(_templateObject$3());

var ForgotPasswordMutation = function ForgotPasswordMutation(props) {
  var onComplete = props.onComplete,
      email = props.email;

  var _useMutation = useMutation(FORGOT_PASSWORD, {
    client: GeladaClient(false)
  }),
      client = _useMutation[0];

  client({
    variables: {
      email: email
    }
  }).then(function (c) {
    onComplete(c, "data");
  })["catch"](function (c) {
    return onComplete(c, "error");
  });
  return null;
};

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n mutation($code:String!,$newPassword:String!){\nforgotPasswordUpdate(code:$code,newPassword:$newPassword)\n}\n\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var FORGOT_PASSWORD_UPDATE = gql(_templateObject$4());

var ForgotPasswordUpdateMutation = function ForgotPasswordUpdateMutation(props) {
  var onComplete = props.onComplete,
      code = props.code,
      newPassword = props.newPassword;

  var _useMutation = useMutation(FORGOT_PASSWORD_UPDATE, {
    client: GeladaClient(false)
  }),
      client = _useMutation[0];

  client({
    variables: {
      code: code,
      newPassword: newPassword
    }
  }).then(function (c) {
    onComplete(c, "data");
  })["catch"](function (c) {
    return onComplete(c, "error");
  });
  return null;
};

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n mutation($email:String!){\n  resendActivationCode(email:$email)\n}\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var RESEND_ACTIVATION_LINK = gql(_templateObject$5());

var ResendActivationCodeMutation = function ResendActivationCodeMutation(props) {
  var onComplete = props.onComplete,
      email = props.email;

  var _useMutation = useMutation(RESEND_ACTIVATION_LINK, {
    client: GeladaClient(false)
  }),
      client = _useMutation[0];

  client({
    variables: {
      email: email
    }
  }).then(function (c) {
    onComplete(c, "data");
  })["catch"](function (c) {
    return onComplete(c, "error");
  });
  return null;
};

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation($user:RegisterUserInputType!,$credential:CredentialInput!){\n  register(user:$user,credential:$credential)\n}\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var SIGN_UP = gql(_templateObject$6());

var SignUpMutation = function SignUpMutation(props) {
  var onComplete = props.onComplete,
      user = props.user,
      credential = props.credential,
      onStart = props.onStart;
  if (onStart) onStart();

  var _useMutation = useMutation(SIGN_UP, {
    client: GeladaClient(false)
  }),
      client = _useMutation[0];

  client({
    variables: {
      user: user,
      credential: credential
    }
  }).then(function (c) {
    onComplete(c, "data");
  })["catch"](function (c) {
    return onComplete(c, "error");
  });
  return null;
};

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation($cPassword:String!,$nPassword:String!){\n  user{\n    updatePassword(currentPassword:$cPassword,newPassword:$nPassword)\n  }\n}\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var UPDATE_PASSWORD = gql(_templateObject$7());

var UpdatePasswordMutation = function UpdatePasswordMutation(props) {
  var onComplete = props.onComplete,
      user = props.user,
      credential = props.credential;

  var _useMutation = useMutation(UPDATE_PASSWORD, {
    client: GeladaClient()
  }),
      client = _useMutation[0];

  client({
    variables: {
      user: user,
      credential: credential
    }
  }).then(function (c) {
    onComplete(c, "data");
  })["catch"](function (c) {
    return onComplete(c, "error");
  });
  return null;
};

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\nquery($token:String!){\n    getInvitation(token:$token){\n      created\n      customMessage\n      emailUserInvited\n      firstName\n      lastName\n      type\n      \n    }\n  }\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var GET_INVITATION = gql(_templateObject$8());

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\nquery{\n    invitation{\n      getInvitationForUser{\n        created\n      }\n    }\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var GET_INVITATION_FOR_USER = gql(_templateObject$9());

var GetInvitationForUserQuery = function GetInvitationForUserQuery(props) {
  var onComplete = props.onComplete;
  var client = useOnPremQuery(GET_INVITATION_FOR_USER, GeladaClient());
  client({}).then(function (c) {
    onComplete(c, "data");
  })["catch"](function (c) {
    return onComplete(c, "error");
  });
  return null;
};

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n  query {\n    user {\n      getLoggedUser {\n        id\n        firstname\n        lastname\n        credential {\n          email\n          secondaryEmail\n        }\n      }\n    }\n  }\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var GET_LOGGED_USER = gql(_templateObject$a());

var GetLoggedUserQuery = function GetLoggedUserQuery(props) {
  var onComplete = props.onComplete;
  var client = useOnPremQuery(GET_LOGGED_USER, GeladaClient());
  client({}).then(function (c) {
    onComplete(c, "data");
  })["catch"](function (c) {
    return onComplete(c, "error");
  });
  return null;
};

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n  query($login: String!, $password: String!) {\n    login(login: $login, password: $password) {\n      token\n      refreshToken\n      user {\n        id\n        firstname\n        created\n        lastname\n        communityName\n        credential {\n          email\n        }\n      }\n    }\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var LOGIN = gql(_templateObject$b());

var LoginQuery = function LoginQuery(props) {
  var onComplete = props.onComplete,
      login = props.login,
      password = props.password,
      customBuildGuid = props.customBuildGuid;
  var client = useOnPremQuery(LOGIN, GeladaClient(false, customBuildGuid));
  client({
    login: login,
    password: password
  }).then(function (c) {
    StoreUserData(c.data.login.user);
    StoreTokens(c.data.login.token, c.data.login.refreshToken);
    onComplete(c, 'data');
  })["catch"](function (c) {
    return onComplete(c, 'error');
  });
  return null;
};

var Token = GeladaRefreshToken();

function _templateObject$c() {
  var data = _taggedTemplateLiteralLoose(["\n  query {\n    getTemporarySession\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var GET_TEMPORARY_TOKEN = gql(_templateObject$c());

function TemporaryToken$1() {
  if (GetAccessToken() !== undefined) return undefined;
  var token = GetTemporaryToken();
  if (token !== undefined && decodeAndVerify(token)) return token;
  GeladaClient(false).query({
    query: GET_TEMPORARY_TOKEN
  }).then(function (c) {
    if (c.data) StoreTemporaryToken(c.data.getTemporarySession);
  })["catch"](function (c) {
    console.warn(c);
    ClearTokens();
  });
  return GetTemporaryToken();
}
function GeladaRefreshToken() {
  var accessToken = GetAccessToken();

  if (accessToken !== undefined) {
    if (decodeAndVerify(accessToken) === false) {
      var refreshToken = GetRefreshToken();
      if (refreshToken === undefined) return undefined;

      if (decodeAndVerify(refreshToken) === false) {
        ClearTokens();
        return undefined;
      }

      GeladaClient(false).query({
        query: REFRESH_TOKEN,
        variables: {
          refreshToken: refreshToken
        }
      }).then(function (c) {
        if (c.data) {
          StoreTokens(c.data.user.refreshToken.token, c.data.user.refreshToken.refreshToken);
          ClearTemporary();
        }

        if (c.errors) {
          ClearTokens();
        }
      })["catch"](function (c) {
        console.warn(c);
        ClearTokens();
      });
    }

    return GetAccessToken();
  }

  return undefined;
}

var __schema = {
	types: [
		{
			kind: "INTERFACE",
			name: "CustomFieldResponseInterfaceGraphType",
			possibleTypes: [
				{
					name: "CustomFieldResponseTextGraphType"
				},
				{
					name: "CustomFieldResponseNumberGraphType"
				},
				{
					name: "CustomFieldResponseDateGraphType"
				},
				{
					name: "CustomFieldResponseMultiResponseGraphType"
				}
			]
		},
		{
			kind: "INTERFACE",
			name: "CustomFieldInterfaceGraphType",
			possibleTypes: [
				{
					name: "CustomFieldTextGraphType"
				},
				{
					name: "CustomFieldNumberGraphType"
				},
				{
					name: "CustomFieldDateGraphType"
				}
			]
		}
	]
};
var introspectionQueryResultData = {
	__schema: __schema
};

var fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: introspectionQueryResultData
});
function GeladaClient(requiredToken, customBuild) {
  if (requiredToken === void 0) {
    requiredToken = true;
  }

  if (customBuild === void 0) {
    customBuild = "";
  }

  var buildGuid = process.env.REACT_APP_PROJECT_ID === undefined ? "" : process.env.REACT_APP_PROJECT_ID;
  if (buildGuid === "") buildGuid = customBuild;
  var cache = new InMemoryCache({
    fragmentMatcher: fragmentMatcher
  });
  var link = new HttpLink({
    uri: process.env.REACT_APP_GELADA_API_URL,
    headers: {
      Authorization: requiredToken ? GeladaRefreshToken() : "",
      Custom_build_guid: buildGuid,
      'Content-Type': 'application/graphql',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': true
    }
  });
  var client = new ApolloClient({
    cache: cache,
    link: link,
    name: 'react-web-client',
    version: '1.3',
    queryDeduplication: false,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network'
      }
    }
  });
  return client;
}

var ActivateAccount = ActiveAccountMutation;
var ForgotPassword = ForgotPasswordMutation;
var ForgotPasswordUpdate = ForgotPasswordUpdateMutation;
var GetLoggedUser = GetLoggedUserQuery;
var GetInvitationForUser = GetInvitationForUserQuery;
var GetTemporaryToken$1 = TemporaryToken$1;
var Login = LoginQuery;
var Refresh = RefreshTokenQuery;
var ResendActivationCode = ResendActivationCodeMutation;
var SignUp = SignUpMutation;
var UpdatePassword = UpdatePasswordMutation;
var AcceptInvitation_Mutation = ACCEPT_INVITATION;
var ActivateAccount_Mutation = ACTIVATE_ACCOUNT;
var ForgotPassword_Mutation = FORGOT_PASSWORD;
var ForgotPasswordUpdate_Mutation = FORGOT_PASSWORD_UPDATE;
var GetInvitation_Query = GET_INVITATION;
var GetLoggedUser_Query = GET_LOGGED_USER;
var Login_Query = LOGIN;
var RefreshToken_Query = REFRESH_TOKEN;
var ResendActivationCode_Mutation = RESEND_ACTIVATION_LINK;
var SignUp_Mutation = SIGN_UP;
var UpdatePassword_Mutation = UPDATE_PASSWORD;
var _eStorageKey = eStorageKey;
var _ClearStorage = ClearStorage;
var _ClearTemporary = ClearTemporary;
var _ClearTokens = ClearTokens;
var _ClearUserData = ClearUserData;
var _GetAccessToken = GetAccessToken;
var _GetRefreshToken = GetRefreshToken;
var _GetStored = GetStored;
var _GetUserData = GetUserData;
var _Store = Store;
var _StoreTokens = StoreTokens;
var Token$1 = GeladaRefreshToken();
var Client = function Client(requireToken) {
  return GeladaClient(requireToken);
};

export { AcceptInvitation_Mutation, ActivateAccount, ActivateAccount_Mutation, Client, ForgotPassword, ForgotPasswordUpdate, ForgotPasswordUpdate_Mutation, ForgotPassword_Mutation, GetInvitationForUser, GetInvitation_Query, GetLoggedUser, GetLoggedUser_Query, GetTemporaryToken$1 as GetTemporaryToken, Login, Login_Query, Refresh, RefreshToken_Query, ResendActivationCode, ResendActivationCode_Mutation, SignUp, SignUp_Mutation, Token$1 as Token, UpdatePassword, UpdatePassword_Mutation, _ClearStorage, _ClearTemporary, _ClearTokens, _ClearUserData, _GetAccessToken, _GetRefreshToken, _GetStored, _GetUserData, _Store, _StoreTokens, _eStorageKey };
//# sourceMappingURL=index.modern.js.map
